import { render, staticRenderFns } from "./RentalObjectFacilities.vue?vue&type=template&id=997f45c2&"
import script from "./RentalObjectFacilities.vue?vue&type=script&lang=js&"
export * from "./RentalObjectFacilities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports